exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base_info .info_list[data-v-53c6e489]{padding:20px 0}.base_info .info_list .tips[data-v-53c6e489]{display:inline-table;padding-left:20px}\n", ""]);

// exports
